// extracted by mini-css-extract-plugin
module.exports = {"icon":"Y_cy","font-size-small":"Y_ds","fontSizeSmall":"Y_ds","font-size-default":"Y_dt","fontSizeDefault":"Y_dt","font-size-large":"Y_dv","fontSizeLarge":"Y_dv"};